import { Serializable } from "../utilities/Serializable";
import { TransactionType } from "./TransactionType";
import { PoS } from "./PoS";
import { CardTransactionProduct } from "./CardTransactionProduct";

export class CardTransaction extends Serializable {
    uuid: string;
    date: Number;
    serverDate: Number;
    movement: Number;
    remainingBalance: Number;
    type: TransactionType;
    pos: PoS;
    code : string;
    cardTransactionProducts: CardTransactionProduct[];
    card: string;
    reversed: Boolean;
    reversed_transaction: String;
    notes: string;
    balanceSnapshot: number;
    balanceVersion: number;
    force: Boolean;

    constructor() {
        super();
        this.date = Date.now();
        this.movement = 0;
        this.remainingBalance = 0;
        this.reversed = false;
        this.cardTransactionProducts = [];
        this.force = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/CardTransaction.ts